import ComicCard from '@/components/feature/ComicCard';
import { comics } from '@/mocks/comics';

export default function RecommendedSection() {
  const recommended = comics.filter((c) => c.isRecommended).slice(0, 6);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            编辑精选
          </h2>
          <p className="text-xs md:text-sm text-foreground-500 mt-1">
            编辑部精心挑选的高品质韩漫
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop>
          {recommended.map((comic) => (
            <div key={comic.id} className="flex justify-center">
              <ComicCard comic={comic} size="large" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}